var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRightOffWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37 18.44"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".arrow-right-offWhite_svg__cls-1{fill:#cedfd7}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right-offWhite_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "arrow-right-offWhite_svg__cls-1",
    d: "M27.09 0l-1.54 1.65 6.93 6.44H0v2.25h32.48l-6.93 6.45 1.54 1.65L37 9.22 27.09 0z",
    id: "arrow-right-offWhite_svg__TOP_BANNER",
    "data-name": "TOP BANNER"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjE1cHgiIHdpZHRoPSIyMnB4IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNyAxOC40NCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+LmNscy0xe2ZpbGw6I2NlZGZkNzt9PC9zdHlsZT4KICA8L2RlZnM+CiAgPGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+CiAgPGcgaWQ9IlRPUF9CQU5ORVIiIGRhdGEtbmFtZT0iVE9QIEJBTk5FUiI+CiAgICA8cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMjcuMDkgMCAyNS41NSAxLjY1IDMyLjQ4IDguMDkgMCA4LjA5IDAgMTAuMzQgMzIuNDggMTAuMzQgMjUuNTUgMTYuNzkgMjcuMDkgMTguNDQgMzcgOS4yMiAyNy4wOSAwIi8+CiAgPC9nPgo8L2c+Cjwvc3ZnPgo=";
export { SvgArrowRightOffWhite as ReactComponent };